/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import { useBlockProps } from '@wordpress/block-editor';
//import metadata from './block.json';
//document.getElementById('ta-map-block').innerHTML = 'test: ' + metadata.attributes.locationIconUrl;
//console.log(metadata.attributes.locationIconUrl);

/*const map = L.map('ta-map-block').setView([60.2122, 24.7499], 15);
	
const LeafIcon = L.Icon.extend({
    options: {
        iconSize:     [50, 50],
        iconAnchor:   [25, 50],
        popupAnchor:  [0, -50]
    }
});

const knitterIcon = new LeafIcon({iconUrl: 'http://oletusteeman-testaus.local/wp-content/uploads/2024/02/virvelikatu5_havainnekuva1-copy.jpg'});

const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
}).addTo(map);

const marker = L.marker([60.2122, 24.7499], {icon: knitterIcon}).addTo(map)
    .bindPopup('<img src="https://ravintolaknitter.fi/wp-content/uploads/2024/01/logo-dark-bg.png"><br>Knitter Business Park <br>Kutojantie 6, 02630 Espoo<br>info@ravintolaknitter.fi');*/

//console.log('view.js: ', useBlockProps);